const RESIZE_MESSAGE_TYPE = "hv-booking-embed-resize";
const EMBED_ROOT_SELECTOR = "[data-booking-embed-root]";
const EMBED_OVERLAY_SELECTOR = "[data-booking-overlay]";

/** Height for iframe auto-resize — includes open floating panels below the card. */
export function measureBookingEmbedHeight(): number {
  const root = document.querySelector(EMBED_ROOT_SELECTOR);
  let height = 0;

  if (root instanceof HTMLElement) {
    height = Math.ceil(root.getBoundingClientRect().bottom);
  } else {
    height = Math.ceil(
      document.documentElement.scrollHeight || document.body.scrollHeight,
    );
  }

  document.querySelectorAll(EMBED_OVERLAY_SELECTOR).forEach((node) => {
    if (!(node instanceof HTMLElement)) return;
    height = Math.max(
      height,
      Math.ceil(node.getBoundingClientRect().bottom + 8),
    );
  });

  return height;
}

/** Tell the parent frame to resize — call when overlays open/close/move. */
export function postBookingEmbedHeight(): void {
  if (typeof window === "undefined") return;
  if (window.parent === window) return;

  window.parent.postMessage(
    {
      type: RESIZE_MESSAGE_TYPE,
      height: measureBookingEmbedHeight(),
    },
    "*",
  );
}
